var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLogo)?_c('img',{staticClass:"v-toolbar-logo",attrs:{"src":_vm.logoUrl}}):_c('div',{staticClass:"v-toolbar__text"},[_vm._v(" "+_vm._s(_vm.fallbackText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }